import { useState } from "react";
import { Get, Set } from "../../../../Request";
import { useSelector, useDispatch } from "react-redux";
import { data } from "jquery";
import {
  RenderPrice,
  ToDateJalali,
  addTime,
  compaireTwoDate,
  renderCategoryRoute,
} from "../../../Common/Function";
import { result } from "lodash";
import moment from "jalali-moment";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { FormSearchSubmit } from "../Components/Services";
const renderIcon = data => {
  switch (data.gender) {
    case "men":
      return (
        <span
          className="gender-table"
          style={{
            fontSize: "9px",
            color: "#000",
          }}
        >
          ویژه آقایان
        </span>
      );
    case "women":
      return (
        <span
          className="gender-table"
          style={{
            fontSize: "9px",
            color: "#000",
          }}
        >
          ویژه بانوان
        </span>
      );
    default:
      break;
  }
};

export const useTableWeek = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [week, setWeek] = useState({
    week: true,
  });
  const [days, setDays] = useState();
  const [loadingWeek, setLoadingWeek] = useState(true);
  const [loadingSans, setLoadingSans] = useState(false);
  const getWeek = data => {
    setLoadingWeek(true);
    Get({
      url: "/timetable/showweeks",
      data: data,
      stat: false,
      toast: true,
      manager: true,
    }).then(res => {
      setWeek(res);
      setDays([
        "Saturday",
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
      ]);
      setLoadingWeek(false);
    });
  };
  const convertDay = day => {
    switch (day) {
      case "Wednesday":
        return "چهارشنبه";
      case "Thursday":
        return "پنج شنبه";
      case "Friday":
        return "جمعه";
      case "Monday":
        return "دوشنبه";
      case "Tuesday":
        return "سه شنبه";
      case "Saturday":
        return "شنبه";
      case "Sunday":
        return "یک شنبه";
      default:
        break;
    }
  };
  const statusHandler = (data, day) => {
    let result = {};
    let center = {
      textAlign: "center",
      verticalAlign: "middle",
    };
    if (
      compaireTwoDate(day, moment().format("YYYY/MM/DD"), data.time) &&
      compaireTwoDate(day, moment().format("YYYY/MM/DD"), data.time) != "today"
    ) {
      result = {
        text: "گذشته ",
        style: {
          backgroundColor: "#fafafa",
          color: "#ccc",
          padding: "14px",
          fontWeight: "200",
          cursor: "not-allowed",
          borderStyle: "dashed",
          borderColor: "#eee",
          ...center,
        },
        status: false,
        pass: true,
      };
    } else {
      if (data && data.status) {
        let stat = data.status;
        if (stat == "future") {
          result = {
            text: "بدون قرارداد ",
            style: {
              backgroundColor: "rgba(0,0,0,0.12)",
              color: "#404040",
              padding: "14px",
              fontWeight: "200",
              borderStyle: "dashed",
              borderColor: "#eee",
              cursor: "not-allowed",
              ...center,
            },
            status: false,
            pass: true,
          };
        } else if (stat == "last") {
          result = {
            text: "گذشته ",
            style: {
              backgroundColor: "rgba(0,0,0,0.12)",
              color: "#404040",
              padding: "14px",
              fontWeight: "200",
              borderStyle: "dashed",
              borderColor: "#eee",
              cursor: "not-allowed",
              ...center,
            },
            status: false,
            pass: true,
          };
        }
      } else {
        if (+data.capacity == -1) {
          result = {
            style: {
              background: "#ffda003d",
              color: "#c89600",
              padding: "14px",
              borderStyle: "dashed",
              borderColor: "#eee",
              borderWidth: 1,
              cursor: "pointer",
              fontWeight: "200",
              ...center,
            },
            empty: true,

            text: "در انتظار رزرو",
          };
        }
        else if (+data.capacity >= 1) {
          result = {
            style: {
              background: "#ddffe9",
              color: "#05974d",
              padding: "14px",
              borderStyle: "dashed",
              borderColor: "#eee",
              borderWidth: 1,
              cursor: "pointer",
              fontWeight: "200",
              ...center,
            },
            status: true,
            needData: true,
          };
        }
        else {
          result = {
            style: {
              background: "#fff2f0",
              color: "#ed4956",
              padding: "14px",
              borderStyle: "dashed",
              borderColor: "#eee",
              borderWidth: 1,
              cursor: "pointer",
              fontWeight: "200",
              ...center,
            },
            empty: true,

            text: "رزرو",
          };
        }
      }
    }

    return result;
  };
  const getDate = (date, week, jalali) => {
    if (week && date) {
      if (jalali) {
        return week.times[date].date;
      }
      return `${ToDateJalali(week.times[date].date).split("/")[1]}/${ToDateJalali(week.times[date].date).split("/")[2]
        }`;
    }
  };
  const getYear = (date, week) => {
    if (date && week) {
      return `${ToDateJalali(week.data[date].date).split("/")[0]}`;
    }
  };

  const checkCurrentWeek = data => {
    let result = false;
    if (data) {
      days.map(day => {
        if (data.data[day].date == new Date().toISOString().split("T")[0]) {
          result = true;
        }
      });
    }

    return result;
  };

  const changeStatus = async data => {
    await dispatch({
      local_storage: {
        key: "basket",
        value: { ...data, step: 1 },
      },
      type: "SET",
      payload: { basket: { ...data, step: 1 } },
    });
    navigate("/card");
  };
  return {
    loadingWeek,
    week,
    getWeek,
    days,
    convertDay,
    statusHandler,
    getDate,
    changeStatus,
    loadingSans,
    checkCurrentWeek,
    getYear,
  };
};

export const useSearch = (isSearch) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { cities, footerDetails } = useSelector(state => state);
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(true);
  const dispatch = useDispatch();
  const [nextLoading, setNextLoading] = useState(false);

  const searchHandler = (data, pageNumber = 1, limit, isApp) => {
    if (isApp) {
      setNextLoading(true)
    }
    else {
      setLoading(true);
    }
    const page = data.page || 1;
    FormSearchSubmit({ ...data, ...renderFilters() }, limit, page).then(
      result => {
        if (isApp) {
          const newData = {
            ...state,
            data: state.data.concat(result.data),
            next_page_url: result.next_page_url,
            current_page: result.current_page
          }
          setState(newData);
          setNextLoading(false)
        }
        else {
          setState(result);
          setLoading(false);
        }
      }
    );
  };
  const getCategory = async () => {
    setLoadingSearch(true);
    await Get({
      url: "/data/need",
      data: {
        needkey: ["category", "cities"],
      },
    }).then(data => {
      dispatch({
        type: "SET",
        payload: {
          categories: data.category,
          cities: data.cities,
        },
      });

      setLoadingSearch(false);
    });
  };
  const search = {
    tag: searchParams.get("tag"),
    item_gender: searchParams.get("item_gender"),
    // city_id: searchParams.get("city_id"),
    title: searchParams.get("title"),
    // category_id: searchParams.get("category_id"),
    sort: searchParams.get("sort"),
    page: searchParams.get("page") || 1,
    name: searchParams.get("name"),
  };
  const handleFilter = (key, value, isApp) => {
    let newSearch = {};
    Object.keys(search).map(key => {
      if (search[key]) {
        newSearch[key] = search[key];
      }
    });
    setSearchParams({ ...newSearch, [key]: value });
    searchHandler(
      {
        tag: searchParams.get("tag"),
        item_gender: searchParams.get("item_gender"),
        city_id: searchParams.get("city_id"),
        title: searchParams.get("title"),
        category_id: searchParams.get("category_id"),
        sort: searchParams.get("sort"),
        name: searchParams.get("name"),
        page: searchParams.get("page") || 1,
        [key]: value,
      },
      search.page,
      15,
      isApp
    );
  };
  const getValue = key => {
    if (key) {
      return search[key];
    }
    return false;
  };
  const clearFilters = () => {
    setSearchParams({});
    searchHandler({}, 1, 15);
  };

  const filterDelete = ele => {
    let newSearch = {};
    Object.keys(search).map(key => {
      if (search[key]) {
        newSearch[key] = search[key];
      }
    });
    delete newSearch[ele];
    setSearchParams({ ...newSearch });
    searchHandler(
      {
        ...newSearch,
      },
      search.page,
      15
    );
  };
  const renderCorrentCity = id => {
    let res = {};
    cities &&
      cities.map(city => {
        if (city.slug == id || city.id == id) {
          res = { ...city };
        }
      });
    return res;
  };
  const { city_slug, name } = useParams();
  const location = useLocation();
  const categoryPath = location.pathname.split("/")[1];
  const renderFilters = () => {
    if (isSearch) {
      return {
        city_id: city_slug,
        name: name
      };
    }
    else {
      return {
        city_id: city_slug,
        category_id: renderCategoryRoute(categoryPath)["id"],
      };
    }
  };

  return {
    loadingSearch,
    search,
    handleFilter,
    searchHandler,
    state,
    loading,
    getCategory,
    getValue,
    clearFilters,
    filterDelete,
    renderFilters,
    nextLoading
  };
};

export const useFilter = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const getTags = async () => {
    setLoading(true);
    await Get({
      url: "/data/need",
      data: {
        needkey: ["usedTags"],
      },
    }).then(data => {
      dispatch({
        type: "SET",
        payload: { tags: data.usedTags },
      });
      setLoading(false);
    });
  };
  return {
    loading,
    getTags,
  };
};
